<script lang="ts">
	import "@glidejs/glide/dist/css/glide.core.min.css";
	import * as Glide from "@glidejs/glide";
	import { disableGlidePerSlideAmount } from "../utils/disableGlidePerSlideAmount";
	import type { ActionReturn } from "svelte/action";
	import arrowLeft from "../../../core/assets/icons/arrow-left.svg?raw";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import Icon from "./Icon.svelte";

	export let items: unknown[] = [];

	function glide(element: HTMLDivElement): ActionReturn {
		const glideOptions = {
			type: "carousel",
			startAt: 0,
			focusAt: 0,
			perView: 4,
			autoplay: 7000,
			hoverpause: false,
			animationDuration: 650,
			animationTimingFunc: "ease-in-out",
			gap: 24,
			keyboard: true,
			cloningRatio: 2,
			breakpoints: {
				1289: { perView: 3.25 },
				1024: { perView: 3 },
				768: { perView: 2.75 },
				640: { perView: 2.65 },
				630: { perView: 2.6 },
				615: { perView: 2.55 },
				600: { perView: 2.5 },
				585: { perView: 2.45 },
				570: { perView: 2.4 },
				555: { perView: 2.35 },
				540: { perView: 2.25 },
				525: { perView: 2.125 },
				500: { perView: 1 },
			},
		} satisfies Partial<Glide.Options>;

		// eslint-disable-next-line new-cap
		const glide = new Glide.default(element, glideOptions).mount();
		glide.on("resize", () => {
			disableGlidePerSlideAmount(glide, element);
		});

		return {
			destroy(): void {
				glide.destroy();
			},
		};
	}
</script>

<div use:glide class="glide relative pb-12 lg:pb-24">
	<div class="glide__track" data-glide-el="track">
		<div class="glide__slides !py-4">
			<slot />
		</div>
		<div
			class="absolute bottom-0 left-0 right-0 mx-auto flex max-w-[20rem] items-center gap-8 min-[500px]:max-w-[34rem]"
			data-glide-el="controls"
		>
			<button
				aria-label="Posuňte doleva"
				data-glide-dir="<"
				class="border-secondary hover:border-primary group flex h-8 w-8 shrink-0 items-center justify-center rounded-full border p-4 transition-colors duration-300 xl:h-[3.5rem] xl:w-[3.5rem]"
			>
				<Icon
					icon={arrowLeft}
					class="group-hover:text-primary text-secondary ml-[.25rem] h-4 transition-colors duration-300 xl:mt-[.1rem] xl:h-6"
				/>
			</button>
			<div class="grow rounded-full">
				<div class="glide__bullets bg-secondary-200 flex h-[.125rem]" data-glide-el="controls[nav]">
					{#each items as _item, index}
						<span
							class="glide__bullet text-secondary hover:bg-secondary-300 w-full cursor-pointer transition-all duration-200"
							data-glide-dir="={index}"
						></span>
					{/each}
				</div>
			</div>
			<button
				aria-label="Posuňte doprava"
				data-glide-dir=">"
				class="border-secondary hover:border-primary group flex h-8 w-8 shrink-0 items-center justify-center rounded-full border p-4 transition-colors duration-300 xl:h-[3.5rem] xl:w-[3.5rem]"
			>
				<Icon
					icon={arrowRight}
					class="group-hover:text-primary text-secondary mr-[.25rem] h-4 transition-colors duration-300 xl:mt-[.1rem] xl:h-6"
				/>
			</button>
		</div>
	</div>
</div>
